// extracted by mini-css-extract-plugin
module.exports =  {"wrapper":"kZb5UfP","title":"VsAidsC","btn-row":"dg2t3a0","btnRow":"dg2t3a0"};